import React from 'react';
import { ErrorLayout } from '@axiom/ui';

export const NotFoundPage = () => (
  <div data-test="not-found-page">
    <ErrorLayout
      name="ERROR_BOUNDARY_LAYOUT"
      errorMessage="Page not found. Please try something else."
    />
  </div>
);
